import { GQLOrderStatusType, GQLPaymentStatusType } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';

export type StatusIconStatus = GQLOrderStatusType | GQLPaymentStatusType;

interface StatusIconProps {
	status: StatusIconStatus;
	className?: string;
}

export function StatusIcon({ status, className }: StatusIconProps) {
	let bgColour = 'bg-blue';

	switch (status) {
		case GQLOrderStatusType.PendingPayment:
		case GQLOrderStatusType.PendingApproval:
		case GQLPaymentStatusType.Pending:
			bgColour = 'bg-orange';
			break;
		case GQLOrderStatusType.Cancelled:
		case GQLPaymentStatusType.Failed:
			bgColour = 'bg-red';
			break;
		case GQLOrderStatusType.Delivered:
		case GQLPaymentStatusType.Complete:
			bgColour = 'bg-green';
			break;
		default:
			break;
	}

	return <div className={cn('rounded-full w-2 h-2', bgColour, className)} />;
}
